module.exports = __webpack_public_path__ + "static/media/droids.b88171c8.gif";